import '../../App.css';
import PaintSection from '../PaintSection';
import react from 'react';

function Paint() {
  return (
    <>
      <PaintSection />
    </>
  );
}

export default Paint;